<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "../home/repeat/Navbar.vue";
import axios from "./../../utils/axios.js";

const router = useRouter();
// 定义新闻列表的响应式变量
const newsList = ref();
// 定义新闻总条数的响应式变量
const totalNews = ref(0);
// 定义当前页码的响应式变量
const currentPage = ref(1);
// 定义每页显示条数的响应式变量
const pageSize = ref(5);

// 获取新闻列表
async function getNewsList(param: { pageSize: number; num: number }) {
  return axios({
    method: "get",
    url: "/framework/news/list",
    params: {
      pageSize: param.pageSize,
      num: param.num,
    },
  });
}
// 获取新闻数据的函数
const fetchNews = async (num: number = 1, pageSize: number = 5) => {
  try {
    const response = await getNewsList({ num, pageSize });
    return response;
  } catch (error) {
    console.error("获取新闻失败：", error.message);
    if (error.response) {
      console.error("状态码:", error.response.status);
      console.error("响应数据:", error.response.data);
    } else if (error.request) {
      console.error("未收到回复：", error.request);
    }
    throw error;
  }
};

// 调用fetchNews函数获取新闻数据
const getNews = async (page: number) => {
  try {
    newsList.value = []; // 先清空当前列表
    const data = await fetchNews(page, pageSize.value);
    setTimeout(() => {
      newsList.value = data.records;
      totalNews.value = data.total;
    }, 100); //
  } catch (error) {
    console.error("获取新闻错误：", error);
  }
};

// 在组件挂载时调用getNews函数，获取当前页的新闻数据
onMounted(() => {
  getNews(currentPage.value);
});

// 处理分页变化的函数
const handlePageChange = (page: number) => {
  // 避免相同页码的重复请求
  if (page === currentPage.value) {
    return;
  }
  currentPage.value = page;
  getNews(page);
};

// 处理新闻点击事件的函数
const handleNewsClick = (id: number) => {
  router.push({
    path: `/news/newpage/${id}`,
  });
};
</script>

<template>
  <div class="news">
    <div class="main">
      <div class="kong">
        <Header></Header>
      </div>
      <div></div>
      <div class="img_box"></div>
      <div class="wrap">
        <div class="wrap_title">
          <div class="title_box">
            <div class="title">
              <a class="no" href="/">{{ $t("system.contact.register.s_y") }}</a>
              <text>></text>
              <a class="th">{{ $t("system.map.news") }}</a>
            </div>
          </div>
        </div>
        <!-- 新闻动态数据 -->
        <div class="content">
          <!--中文-->
          <div class="content_box" v-if="$i18n.locale === 'zh-cn'">
            <transition-group
              name="news-list"
              tag="div"
              appear
              :key="currentPage"
            >
              <div
                v-for="news in newsList"
                :key="news.id"
                class="news-item"
                @click="handleNewsClick(news.id)"
              >
                <div class="news-item-left">
                  <img :src="news.img" alt="news image" v-if="news.img" />
                </div>
                <div class="news-item-right">
                  <h2>{{ news.title }}</h2>
                  <div class="news-info">
                    <p class="news-desc">{{ news.type }}</p>
                    <span class="news-date">{{
                      news.createTime.split(" ")[0]
                    }}</span>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
          <!--  英文-->
          <div class="content_box" v-if="$i18n.locale === 'en'">
            <transition-group
              name="news-list"
              tag="div"
              appear
              :key="currentPage"
            >
              <div
                v-for="news in newsList"
                :key="news.id"
                class="news-item"
                @click="handleNewsClick(news.id)"
              >
                <div class="news-item-left">
                  <img :src="news.img" alt="news image" v-if="news.img" />
                </div>
                <div class="news-item-right">
                  <h2>{{ news.titleEn }}</h2>
                  <div class="news-info">
                    <p class="news-desc">{{ news.typeEn }}</p>
                    <span class="news-date">{{
                      news.createTime.split(" ")[0]
                    }}</span>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>

      <!-- 分页器 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="totalNews"
          :current-page.sync="currentPage"
          @current-change="handlePageChange"
          :hide-on-single-page="true"
        >
        </el-pagination>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"></Navbar>
    <router-view></router-view>
  </div>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.main {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.kong {
  max-width: 1200px;
  height: 120px;
}

.img_box {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../assets/imgs/prodList_backgronud.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}

.wrap {
  width: 100%;
  height: auto;
}

.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  background-color: #fff;
  font-size: 14px;
  height: 86px;
}

.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
}

.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}

.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}

.content_box {
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}

.news-item {
  display: flex;
  align-items: flex-start;
  margin: 50px 0;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);

    .news-item-left img {
      transform: scale(1.05);
    }

    .news-item-right {
      background-color: #f8f9fa;
      border-radius: 4px;
    }

    .news-item-right h2 {
      color: #007bff;
    }
  }
}
@keyframes slideUp {
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.news-item:hover {
  transform: translateY(-5px);
}

.news-item-left {
  flex: 0 0 300px;
  height: 200px;
  overflow: hidden;
  border-radius: 4px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
}

.news-item-left img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  transition: transform 0.3s;
}

.news-item:hover .news-item-left img {
  transform: scale(1.05);
}

.news-item-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 200px;
  padding: 20px;
  transition: background-color 0.3s ease;

  h2 {
    font-size: 24px;
    color: #333;
    margin: 0;
    line-height: 1.4;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
.news-info {
  margin-top: auto;
}

.news-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-date {
  display: block;
  color: #999;
  font-size: 14px;
}
.news-item-right p {
  margin: 10px 0 0;
  color: #777;
  transition: color 0.3s;
}

.news-item:hover .news-item-right h2 {
  color: #007bff;
}

.news-item:hover .news-item-right p {
  color: #555;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.news-list-enter-active,
.news-list-leave-active {
  transition: all 0.5s ease;
}

.news-list-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.news-list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.news-item {
  animation: fadeInUp 0.6s ease-out forwards;
  opacity: 0;

  @for $i from 1 through 10 {
    &:nth-child(#{$i}) {
      animation-delay: #{$i * 0.1}s;
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
